<template>
  <div id="device-info" class="page" v-if="organization">
    <content-nav-bar>
      <p class="is-size-4">Organization Info</p>
    </content-nav-bar>
    <detail-item
      name="Name"
      imgName="name">
      {{ organization.name }}
    </detail-item>
    <detail-item
      name="Created"
      imgName="cal">
      {{ organization.created | formatEpochDate(gmt) }}
    </detail-item>
    <detail-item
      name="Domain"
      imgName="org">
      {{ organization.hd }}
    </detail-item>
    <detail-item
      name="Users"
      imgName="org">
      <p v-for="user in organization.users" :key="user">{{ user }}</p>
    </detail-item>
    <detail-item
      name="Certificate Authority ID"
      imgName="cert">
      {{ organization.caid }}
    </detail-item>
    <build-info></build-info>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import gmt from '@/mixins/gmt';
import DetailItem from '@/components/DetailItem.vue';
import ContentNavBar from '@/components/ContentNavBar.vue';
import BuildInfo from '@/views/BuildInfo.vue';

export default {
  name: 'AccountSection',
  components: { DetailItem, ContentNavBar, BuildInfo },
  mixins: [gmt],
  computed: {
    ...mapState('primary', ['organization']),
  },
  mounted() {
    this.SET_SECTION('Account Info');
  },
  methods: {
    ...mapMutations(['SET_SECTION']),
  },
};
</script>
